/**
 * storeの初期値を準備する
 */

export const initialState = {
    mainpage: {
        todayProverb: "",
        counter: 0
    },
    cleaningPlace: {
        cleaningList: []
    },
    loading: {
        state: false,
        text: ""
    },
    user: {
        isSignedIn: false
    }
};